import {motion} from 'framer-motion';
import Card from "../shared/Card";
import GeneralContext from '../../context/GeneralContext';
import { useContext } from 'react';
import ButtonFunction from '../shared/ButtonFunction';
import { FaUsers } from "react-icons/fa";

function ManageUsers() {

    const { changeCurrentMenu } = useContext(GeneralContext);

    return (
      <motion.div
        key='adminManageUsers'
        initial={{opacity: 0, x: -1000}}
        animate={{opacity: 1, x: 0}}
        exit={{opacity: 0, x: -1000, transition:{duration: 0.5, delay: 0}}}
        transition={{duration: 0.5}}>
          <Card>
            <FaUsers size='50px'/>
            <h2>Gestionar Usuarios</h2>
            <ButtonFunction
              buttonFunction={changeCurrentMenu}
              buttonArguments={'add-user'}
              buttonClass='adminButton'
            >
              Registrar Usuario
            </ButtonFunction>
            <br />
            <br />
            <ButtonFunction
              buttonFunction={changeCurrentMenu}
              buttonArguments={'active-users'}
              buttonClass='adminButton'
            >
              Usuarios Activos
            </ButtonFunction>
            <br />
            <br />
            <ButtonFunction
              buttonFunction={changeCurrentMenu}
              buttonArguments={'inactive-users'}
              buttonClass='adminButton'
            >
              Usuarios Inactivos
            </ButtonFunction>
          </Card>
      </motion.div>
    )
}

export default ManageUsers